import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/appRoutes";

import * as Sentry from "@sentry/react";

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

const AppWithProfiler = Sentry.withProfiler(App);
export default AppWithProfiler;
